var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-calendar"},[_c('vue-cal',{attrs:{"hide-view-selector":"","events":_vm.events,"time":false,"default-view":"month","events-on-month-view":"short"},on:{"ready":_vm.fetchEvents,"view-change":_vm.fetchEvents}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }